import { Patient } from 'types/types';
import { translatePatient } from 'modules/patients/utils/translatePatient';

export const translatePatientList = (response: object[]): Patient[] =>
  response.map(translatePatient);
